export interface CreditosUsario {
  id_usuario: string;
  nombres: string;
  apellidos: string | null;
  email: string;
  creditos_totales: number;
  creditos_gastados: number;
  creditos_disponibles: number;
  creditos_desperdiciados: number;
}

export interface CreditosSuborganizacion {
  id_suborganizacion: string;
  suborganizacion: string;
  creditos_totales: number;
  creditos_gastados: number;
  creditos_disponibles: number;
  creditos_desperdiciados: number;
}

export interface CreditosOrganizacion {
  id_organizacion: string;
  organizacion: string;
  creditos_totales: number;
  creditos_gastados: number;
  creditos_disponibles: number;
  creditos_desperdiciados: number;
}

export interface CreditosSuscripcion {
  id_suscripcion: string;
  plan: string;
  creditos_totales: number;
  creditos_gastados: number;
  creditos_disponibles: number;
  creditos_desperdiciados: number;
}

export interface CreditosMensuales {
  month: string;
  creditos_gastados: number;
  creditos_desperdiciados: number;
  creditos_disponibles: number;
  pastMonth: boolean;
  id_suscripciones: string[];
}

export interface CreditosMensualesOrg {
  id_organizacion: string;
  start_date: string;
  end_date: string;
  start_month: number;
  start_year: number;
  months: number;
  sublimaciones: CreditosMensuales[];
}

export interface CreditosMensualesSuscrip {
  id_suscripcion: string;
  start_date: string;
  end_date: string;
  start_month: number;
  start_year: number;
  months: number;
  sublimaciones: CreditosMensuales[];
}

export interface CreditosMensualesUser {
  id_usuario: string;
  start_date: string;
  end_date: string;
  start_month: number;
  start_year: number;
  months: number;
  sublimaciones: CreditosMensuales[];
}

export interface CreditosMensualesSuborg {
  id_suborganizacion: string;
  start_date: string;
  end_date: string;
  start_month: number;
  start_year: number;
  months: number;
  sublimaciones: CreditosMensuales[];
}

export interface InfoCredits {
  id_usuario: string;
  suscripciones: string[];
  creditos_totales: number;
  creditos_gastados_mes: number;
  creditos_disponibles: number;
}

export interface MonthYear {
  month: number;
  year: number;
}

export interface BarFilters {
  credits: {
    value:
      | "creditos_gastados"
      | "creditos_disponibles"
      | "creditos_desperdiciados";
    label: string;
    isActive: boolean;
    color: string;
  }[];
}

export const initalBarFilters: BarFilters = {
  credits: [
    {
      value: "creditos_disponibles",
      label: "Disponibles",
      isActive: true,
      color: "#133E87",
    },
    {
      value: "creditos_gastados",
      label: "Gastados",
      isActive: true,
      color: "#608BC1",
    },
    {
      value: "creditos_desperdiciados",
      label: "Desperdiciados",
      isActive: true,
      color: "#CBDCEB",
    },
  ],
};
